module.exports = __webpack_public_path__ + "img/Mini.f687d05e.png";